import NativeBridge from './bridge'
function bridgePlugin (Vue, carisokConfig) {
    const config = new NativeBridge(carisokConfig)
    Vue.$bridge = config
    Vue.prototype.$bridge = config
}

function useBridge (Vue, carisokConfig) {
    Vue.use(bridgePlugin, carisokConfig)
}

export default useBridge
